const fallbackFooterData = {
  resourceLinks: [],
  legalLinks: [],
  socialLinks: [],
  seoLinkSections: []
};
export {
  fallbackFooterData
};
